import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { z } from 'zod'
import { api } from '@/lib/api'

/**
 * A linha da sessão marcada, em claro.
 *
 * O console precisa dela por dois motivos: o paciente, que decide qual DEK
 * abre as medidas, e o fim previsto, que é o que o alerta de fechamento
 * compara com o relógio. Nada aqui diz nada sobre a pessoa, então é query
 * normal, fora do cache cifrado.
 */

export const sessaoSchema = z.object({
  id: z.uuid(),
  patientId: z.uuid().nullable(),
  startsAt: z.iso.datetime({ offset: true }),
  endsAt: z.iso.datetime({ offset: true }),
  status: z.string(),
})

export type Sessao = z.infer<typeof sessaoSchema>

export function sessaoQueryKey(sessionId: string): readonly unknown[] {
  return ['sessao', sessionId]
}

export function useSessao(sessionId: string | undefined): UseQueryResult<Sessao, Error> {
  return useQuery({
    queryKey: sessaoQueryKey(sessionId ?? ''),
    enabled: sessionId !== undefined,
    queryFn: () => api(`/api/sessions/${sessionId}`, { schema: sessaoSchema }),
  })
}
